import React, { useCallback, useState } from 'react';

import PropTypes from 'prop-types';

import { useDomain } from '../../../techstyle-shared/redux-core';
import { useLDFlags } from '../../utils/LD/useLDFlags';
import { Component as AfterpaySnippet } from '../AfterpaySnippet';
import { Component as ClearpaySnippet } from '../ClearpaySnippet';
import KlarnaSnippet from '../KlarnaSnippet/KlarnaSnippet';

const Context = React.createContext(false);

// ? This is used inside of the `savagexExtension`, does this need to be on all pages?
function PaymentMethodProvider({ children }) {
  const [isAfterPayReady, setIsAfterpayReady] = useState(false);
  const [isKlarnaReady, setIsKlarnaReady] = useState(false);
  const [klarnaSnippetReady, setKlarnaSnippetReady] = useState(false);

  const { tld } = useDomain();
  const { 'additional-payment-methods': additionalPaymentMethods } =
    useLDFlags();

  const isAfterpayEnabled =
    additionalPaymentMethods === 'afterpay' ||
    additionalPaymentMethods === 'both';
  const isKlarnaEnabled =
    additionalPaymentMethods === 'klarna' ||
    additionalPaymentMethods === 'both';

  const handleAfterpayReady = useCallback(() => {
    setIsAfterpayReady(true);
  }, []);

  const handleKlarnaReady = useCallback(() => {
    setIsKlarnaReady(true);
  }, []);

  return (
    <Context.Provider
      value={{
        isAfterPayReady,
        isKlarnaReady,
        setKlarnaSnippetReady,
        klarnaSnippetReady,
      }}
    >
      {tld === '.com' && isAfterpayEnabled ? (
        <AfterpaySnippet onReady={handleAfterpayReady} />
      ) : null}
      {tld === '.com' && isKlarnaEnabled && klarnaSnippetReady ? (
        <KlarnaSnippet onReady={handleKlarnaReady} />
      ) : null}
      {tld === '.co.uk' ? (
        <ClearpaySnippet onReady={handleAfterpayReady} />
      ) : null}
      {children}
    </Context.Provider>
  );
}

PaymentMethodProvider.propTypes = {
  children: PropTypes.node,
};

PaymentMethodProvider.Context = Context;

export default PaymentMethodProvider;
